import { Action } from '@ngrx/store';
import { CartDetailDTO, CartSummaryDTO } from 'src/app/core/models/shopping-cart';

export enum ShoppingCartActionTypes {
  TEMP_SHOPPINGCART_LOAD = 'TEMP_SHOPPINGCART_LOAD',
  TEMP_SHOPPINGCART_LOAD_SUCCESS = 'TEMP_SHOPPINGCART_LOAD_SUCCESS',
  TEMP_SHOPPINGCART_LOAD_FAIL = 'TEMP_SHOPPINGCART_LOAD_FAIL',
  TEMP_SHOPPINGCART_LOAD_UPDATE = 'TEMP_SHOPPINGCART_LOAD_UPDATE',
  SHOPPINGCART_LOAD = 'SHOPPINGCART_LOAD',
  SHOPPINGCART_LOAD_SUCCESS = 'SHOPPINGCART_LOAD_SUCCESS',
  SHOPPINGCART_LOAD_FAIL = 'SHOPPINGCART_LOAD_FAIL',
  SHOPPINGCART_LOAD_UPDATE = 'SHOPPINGCART_LOAD_UPDATE',
}

export class TempShoppingCartLoad implements Action {
  readonly type = ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD;
  constructor(public idMember: number) {}
}

export class TempShoppingCartLoadSuccess implements Action {
  readonly type = ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_SUCCESS;
  constructor(public data: CartDetailDTO[]) {}
}

export class TempShoppingCartLoadFail implements Action {
  readonly type = ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_FAIL;
  constructor(public data: { error: string }) {}
}

export class TempShoppingCartDetailsUpdate implements Action {
  readonly type = ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_UPDATE;
  constructor(public data: CartDetailDTO[]) {}
}
export type TempShoppingCartActions =
  | TempShoppingCartLoad
  | TempShoppingCartLoadSuccess
  | TempShoppingCartLoadFail
  | TempShoppingCartDetailsUpdate;

export class ShoppingCartLoad implements Action {
  readonly type = ShoppingCartActionTypes.SHOPPINGCART_LOAD;
  constructor(public idMember: number) {}
}

export class ShoppingCartLoadSuccess implements Action {
  readonly type = ShoppingCartActionTypes.SHOPPINGCART_LOAD_SUCCESS;
  constructor(public data: CartSummaryDTO[]) {}
}

export class ShoppingCartLoadFail implements Action {
  readonly type = ShoppingCartActionTypes.SHOPPINGCART_LOAD_FAIL;
  constructor(public data: { error: string }) {}
}

export class ShoppingCartDetailsUpdate implements Action {
  readonly type = ShoppingCartActionTypes.SHOPPINGCART_LOAD_UPDATE;
  constructor(public data: CartSummaryDTO[]) {}
}

export type ShoppingCartActions =
  | ShoppingCartLoad
  | ShoppingCartLoadSuccess
  | ShoppingCartLoadFail
  | ShoppingCartDetailsUpdate;
